// extracted by mini-css-extract-plugin
export default {"main":"Heading_main__sntpa","heading":"Heading_heading__9Fmtr"};